import { timetables } from '@/externals/gyym/user'
import { ListParams, TimetableId } from '@/externals/gyym/user/timetables/types'
import { sortActivities } from '../Activities'

export const listTimetable = async (params: ListParams) => {
  const { data, meta } = await timetables.list(params)

  return {
    data: data.map(({ program, ...timetables }) => ({
      ...timetables,
      program: {
        ...program,
        // プログラムのアクティビティを並べ替える
        activities: sortActivities(program.activities),
      },
    })),
    meta,
  }
}

export const listOnlineTimetable = async (params: ListParams) => {
  const { data, meta } = await timetables.list({ ...params, isOnline: true })

  return {
    data: data.map(({ program, ...timetables }) => ({
      ...timetables,
      program: {
        ...program,
        // プログラムのアクティビティを並べ替える
        activities: sortActivities(program.activities),
      },
    })),
    meta,
  }
}

export const isReservableTimetable = async (timetableId: TimetableId) => {
  return await timetables.isReservable(timetableId)
}
